import { useQuery } from '@tanstack/react-query';

import { getKurlyMallConfig } from '../services/kurlyMallEffects.service';
import { KURLY_MALL_CONFIG } from '../utils/kurlyMallEffectsQueryKey';

export const useConfig = () => {
  return useQuery(KURLY_MALL_CONFIG, getKurlyMallConfig);
};
